import {StringUDF} from "./UDFs/StringUDF";
import {BooleanUDF} from "./UDFs/BooleanUDF";
import {NumberUDF} from "./UDFs/NumberUDF";

export class AppParametersConfiguration {

  AllDepartmentEnabled: BooleanUDF;

  AutoPadRFID: BooleanUDF;

  AutoPadSKU: BooleanUDF;

  AutoPadUPC: BooleanUDF;

  DefaultDepartment: StringUDF;

  DefaultZone: StringUDF;

  DisableUPCCheck: BooleanUDF;

  EnableTimestamp: BooleanUDF;

  OfflineMode: BooleanUDF;

  RFIDValidation: StringUDF;

  SKUValidation: StringUDF;

  UPCValidation: StringUDF;

  RFIDLength: StringUDF;

  SKULength: StringUDF;

  UPCLength: StringUDF;

  Group: StringUDF;

  ZoneDeptRelationThingTypeCode: StringUDF;

  VisibilityGroupId: StringUDF;

  RequestTimeout: NumberUDF;

  RenewTokenAttempts:NumberUDF;

  ViZIxEventSerial: StringUDF;

  ItemEventUDF:StringUDF;

  ZoneReportId: NumberUDF;

  FilterLabelStoreId: StringUDF;

  FilterLabelZoneTypeProperty: StringUDF;

  DownloadInterval : NumberUDF;

  EnableGzipCompression:BooleanUDF;

  ThingTypeCodeItem:StringUDF;

  ThingTypeCodeProduct:StringUDF;

  get(): any {
    return {
      AllDepartmentEnabled:this.AllDepartmentEnabled.value,
      AutoPadRFID: this.AutoPadRFID.value,
      AutoPadSKU: this.AutoPadSKU.value,
      AutoPadUPC: this.AutoPadUPC.value,
      DefaultDepartment: this.DefaultDepartment.value,
      DefaultZone: this.DefaultZone.value,
      DisableUPCCheck: this.DisableUPCCheck.value,
      DownloadInterval: this.DownloadInterval.value,
      EnableTimestamp: this.EnableTimestamp,
      OfflineMode: this.OfflineMode.value,
      RFIDValidation: this.RFIDValidation.value,
      SKUValidation: this.SKUValidation.value,
      UPCValidation: this.UPCValidation.value,
      RFIDLength: this.RFIDLength.value,
      SKULength: this.SKULength.value,
      UPCLength: this.UPCLength.value,
      ZoneDeptRelationThingTypeCode: this.ZoneDeptRelationThingTypeCode.value,
      VisibilityGroupId: this.VisibilityGroupId.value,
      RequestTimeout: this.RequestTimeout.value,
      RenewTokenAttempts:this.RenewTokenAttempts.value,
      ViZIxEventSerial:this.ViZIxEventSerial.value,
      ItemEventUDF:this.ItemEventUDF.value,
      ZoneReportId:this.ZoneReportId.value,
      FilterLabelStoreId:this.FilterLabelStoreId.value,
      FilterLabelZoneTypeProperty:this.FilterLabelZoneTypeProperty.value,
      EnableGzipCompression:this.EnableGzipCompression.value,
      ThingTypeCodeItem:this.ThingTypeCodeItem,
      ThingTypeCodeProduct:this.ThingTypeCodeProduct

    }
  }
}



// WEBPACK FOOTER //
// ./src/models/appParameters.config.ts